import { atom, useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'

import { GroupCountsFigures } from '~/components/features/GroupCountsFigures'
import { AmplitudeProvider } from '~/components/providers/AmplitudeEventProvider'
import { groups, toGroupIndex } from '~/utils'

import {
  commentAtom,
  dataDisplayTypeAtom,
  groupNameMapAtom,
  groupsDiffsAtom,
  hiddenColumnKeysAtom,
  hiddenRowIdsAtom,
  individualSortValueAtom,
  matrixSortValueAtom,
  questionsDiffsMapAtom,
  resultViewerTypeAtom,
  savedCommentAtom,
  sequentialSortValueAtom,
  tabulationQueryDataAtom,
} from '../atoms'
import { useCreateRestoringParams } from '../hooks/restoringParams/useCreateRestoringParams'
import { useCreateFigureInfo } from '../hooks/useCreateFigureInfo'
import { useGroupDefinitionMap } from '../hooks/useGroupDefinitionMap'
import { useSurveyId } from '../hooks/useSurveyId'

const questionQueryDataAtom = atom(
  (get) => get(tabulationQueryDataAtom)?.answers ?? null,
)
const customerAttributeQueryDataAtom = atom(
  (get) => get(tabulationQueryDataAtom)?.customerAttributes ?? null,
)

export const GroupCountsFiguresContainer = () => {
  const { t } = useTranslation()
  const createFigureInfo = useCreateFigureInfo()
  const createRestoringParams = useCreateRestoringParams()
  const surveyId = useSurveyId()
  const groupDefinitionMap = useGroupDefinitionMap()

  const setGroupNameMap = useSetAtom(groupNameMapAtom)

  React.useEffect(() => {
    setGroupNameMap(
      R.mapToObj(groups, (group) => [
        group,
        t('grouptogroupindexgroup', { toGroupIndex: toGroupIndex(group) }),
      ]),
    )
  }, [t, setGroupNameMap])

  return (
    <AmplitudeProvider eventNameSuffix="_customized analysis">
      <GroupCountsFigures
        commentAtom={commentAtom}
        createFigureInfo={createFigureInfo}
        createRestoringParams={createRestoringParams}
        customerAttributeQueryDataAtom={customerAttributeQueryDataAtom}
        dataDisplayTypeAtom={dataDisplayTypeAtom}
        groupDefinitionMap={groupDefinitionMap}
        groupNameMapAtom={groupNameMapAtom}
        groupsDiffsAtom={groupsDiffsAtom}
        hiddenColumnKeysAtom={hiddenColumnKeysAtom}
        hiddenRowIdsAtom={hiddenRowIdsAtom}
        individualSortValueAtom={individualSortValueAtom}
        matrixSortValueAtom={matrixSortValueAtom}
        outputType="customizedAnalysis"
        questionQueryDataAtom={questionQueryDataAtom}
        questionsDiffsMapAtom={questionsDiffsMapAtom}
        resultViewerTypeAtom={resultViewerTypeAtom}
        savedCommentAtom={savedCommentAtom}
        sequentialSortValueAtom={sequentialSortValueAtom}
        surveyId={surveyId}
      />
    </AmplitudeProvider>
  )
}
